export const Utils = {

  positions: [
    {id: "1", position: {abr: "B", name: "Base"}},
    {id: "1.5", position: {abr: "B/E", name: "Base/Escolta"}},
    {id: "2", position: {abr: "E", name: "Escolta"}},
    {id: "2.5", position: {abr: "E/A", name: "Escolta/Alero"}},
    {id: "3", position: {abr: "A", name: "Alero"}},
    {id: "3.5", position: {abr: "A/A-P", name: "Alero/Ala-Pívot"}},
    {id: "4", position: {abr: "A-P", name: "Ala Pívot"}},
    {id: "4.5", position: {abr: "A-P/P", name: "Ala Pívot/Pívot"}},
    {id: "5", position: {abr: "P", name: "Pívot"}}
  ],

  getPositionById: positionId => {
    const positionResult = Utils.positions.filter(position => position.id === positionId.toString())
    if (positionResult.length > 0){
      return positionResult[0]
    } else {
      return null
    }
  },
  addDoublePositions: (positions) => {
    const doublePositions = []
    positions.forEach(position => {
      if (position === "1") {
        doublePositions.push("1.5")
      }
      if (position === "2") {
        doublePositions.push("1.5")
        doublePositions.push("2.5")
      }
      if (position === "3") {
        doublePositions.push("2.5")
        doublePositions.push("3.5")
      }
      if (position === "4") {
        doublePositions.push("3.5")
        doublePositions.push("4.5")
      }
      if (position === "5") {
        doublePositions.push("4.5")
      }
    });
    return positions.concat(doublePositions)
  },
  getAge: birthDate => {
    if (birthDate !== undefined) {
      const parts = birthDate.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; 
      const year = parseInt(parts[2], 10);
      const dateFormatted = new Date(year, month, day);

      const today = new Date();

      let age = today.getFullYear() - dateFormatted.getFullYear();
      const monthDifference = today.getMonth() - dateFormatted.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dateFormatted.getDate())) {
        age--;
      }

      return age;
    } else {
      return ''
    }
  },
  getDecimalAge: birthDateString => {
    const [day, month, year] = birthDateString.split('/').map(Number);
    const birthDate = new Date(year, month - 1, day);
    const currentDate = new Date();
  
    // Calcular la diferencia en milisegundos
    const diffInMilliseconds = currentDate - birthDate;
  
    // Convertir la diferencia a años
    const millisecondsInAYear = 1000 * 60 * 60 * 24 * 365.25; // Año bisiesto considerado
    const ageInDecimalYears = diffInMilliseconds / millisecondsInAYear;
  
    return Number(ageInDecimalYears.toFixed(2));
  },
  compareDateWithToday: dateToCompare => {
    if (dateToCompare === undefined) {
      return 0
    }
    const today = new Date();
    const todayOnlyDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const inputOnlyDate = Utils.parseDate(dateToCompare, false)

    if (inputOnlyDate > todayOnlyDate) {
      return 1;
    } else if (inputOnlyDate < todayOnlyDate) {
      return -1;
    } else {
      return 0;
    }
  
  },
  compareDates: (dateA, dateB) => {
    if (dateA === undefined || dateB === undefined) {
      return 0
    }
    const inputDateA = Utils.parseDate(dateA, true)
    const inputDateB = Utils.parseDate(dateB, true)
    if (inputDateA > inputDateB) {
      return 1;
    } else if (inputDateA < inputDateB) {
      return -1;
    } else {
      return 0;
    }
  },
  parseDate: (dateString, isTime) => {
    const parts = dateString.split('T')
    const dateParts = parts[0].split('-')
    const day = parseInt(dateParts[2], 10)
    const month = parseInt(dateParts[1], 10) - 1
    const year = parseInt(dateParts[0], 10)
    if (!isTime) {
      return new Date(year, month, day)
    } else {
      const timeParts = parts[1].split(':')
      const hours = parseInt(timeParts[0], 10)
      const minutes = parseInt(timeParts[1], 10)
      return new Date(year, month, day, hours, minutes, 0)
    }
  },
  parseSpanishDate: dateString => {
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day)
  },
  formatSpanishDate: date => {
    return date.toLocaleDateString('es-ES', {
      weekday:"long",
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  },
  licences: [
    {abr: 'JFL', name: 'Formación'},
    {abr: 'EUR', name: 'Comunitario'},
    {abr: 'COT', name: 'Cotonou'},
    {abr: 'EXT', name: 'Extracomunitario'},
  ],
  getLicence: licenceAbr => {
    const results = Utils.licences.filter(licence => licence.abr === licenceAbr)
    if (results.length > 0) {
      return results[0].name
    } else {
      return null
    }
  },

  formatLeague: league => {
    const leagueParts = league.split("_");
    if (leagueParts.length === 1) {
      return leagueParts[0];
    }
    if (leagueParts.length === 2) {
      return leagueParts[0] + " (" + leagueParts[1] + ")";
    }
  },

  decimalDiv: (a, b, decimals) => {
    if (b > 0) {
      return Number(a / b).toFixed(decimals)
    } else {
      return 0
    }
  },

  showDateStr: dateNotFormatted => {
    return new Date(dateNotFormatted).toLocaleDateString()+" "+Utils.showTimeStr(dateNotFormatted)
  },

  showTimeStr: dateNotFormatted => {
    const time = new Date(dateNotFormatted).toLocaleTimeString()
    const timeArr = time.split(":")
    if (timeArr.length > 1){
      return timeArr[0]+":"+timeArr[1]
    }
    return ""
  },

  generateRandomId: length => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
  
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
  
    return result;
  },

  replaceItemInArray: (array, newItem) => {
    const index = array.findIndex(item => item.id === newItem.id);
    if (index !== -1) {
      array[index] = newItem;
    }
  },

  splitArray: (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
  },
  showFlagCountry: (countries, countryName, text) => {
    const countryArr = countries.filter(country => country.name === countryName)
    if (countryArr.length > 0){
      if (text) {
        return '<img className="country-flag" src="./assets/flags/'+countryArr[0].path+'" alt="'+countryArr[0].path+'"></img>'
      }
      return <img className="country-flag" src={`./assets/flags/${countryArr[0].path}`} alt={countryArr[0].path}></img>
    } else {
      if (text) {
        return ""
      }
      return <></>
    }
  }
}